import { render, staticRenderFns } from "./ConfirmEmailView.vue?vue&type=template&id=2958cb48&scoped=true"
import script from "./ConfirmEmailView.vue?vue&type=script&lang=ts"
export * from "./ConfirmEmailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2958cb48",
  null
  
)

export default component.exports